import { useDispatch, useSelector } from "react-redux";
import { setMainLoading, setPageTitle } from "../../Store/reducers/Common";
import { useEffect, useMemo, useState } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { PostAxios, responseCatchFunc } from "../../Services/RequestService";
import { ConvertErrorArrayToString } from "../../Services/Common";
import { setToastData } from "../../Store/reducers/Toast";
import { Link } from "react-router-dom";
import Pagination from "../../Services/Pagination";
import moment from "moment";


const DivisionTransfer = () => {
    const dispatch = useDispatch();
    const { userData, accessToken } = useSelector((state) => state.user);
    const [filter, setFilter] = useState({
        org_id: userData.role_slug === "super_admin" ? 0 : userData.org_id,
        div_id: userData.role_slug === "super_admin" || userData.role_slug === "org_admin" ? 0 : userData.user_div,
    });
    const [orgList, setOrgList] = useState([]);
    const [divList, setDivList] = useState([]);
    const [transferList, setTransferList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationData, setPaginationData] = useState({ total: 0, per_page: 20 });
    const [showFilter, setShowFilter] = useState(true);
    const filterHandler = (key, value) => {
        setFilter({ ...filter, [key]: value });
    }
    useEffect(() => {
        dispatch(setPageTitle('Division Transfer'));
        dispatch(setMainLoading(true));
        let promiseArray = [];
        if (userData.role_slug === "super_admin") {
            promiseArray.push(PostAxios(`masters/organization`, { page: 1, perPage: 1000 }, accessToken));
        }
        if (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") {
            promiseArray.push(PostAxios(`masters/division-list`, { org_id: userData.role_slug === "super_admin" ? 0 : userData.org_id, page: 1, perPage: 1000 }, accessToken));
        }
        if (promiseArray.length > 0) {
            Promise.all(promiseArray)
                .then((response) => {
                    if (response[0].config.url === "masters/organization") {
                        if (response[0].data.status === "1") {
                            setOrgList(response[0].data.data);
                        }
                    }
                    else {
                        if (response[0].data.status === "1") {
                            setDivList(response[0].data.data);
                        }
                    }
                    if (response?.[1]?.config?.url === "masters/division-list") {
                        if (response[1].data.status === "1") {
                            setDivList(response[1].data.data);
                        }
                    }
                    fetchTransferList(1);
                })
                .catch(err => {
                    console.log(err);
                }).finally(() => {
                    dispatch(setMainLoading(false));
                })
        }
        else {
            fetchTransferList();
        }
    }, [accessToken, dispatch]);
    const fetchTransferList = (pageNo = 0) => {
        dispatch(setMainLoading(true));
        let postData = {
            ...filter
        }
        if (pageNo > 0) {
            postData.page = pageNo
            postData.perPage = paginationData.per_page
        }
        PostAxios(`users/transfer-request-list`, postData, accessToken)
            .then(({ data }) => {
                if (data.status === "1") {
                    setPaginationData({ total: data.totalRecords, per_page: data.perPage });
                    setTransferList(data.data);
                }
                else {
                    setPaginationData({ total: 0, per_page: 20 });
                    setTransferList([]);
                }
            })
            .catch((err) => {
                responseCatchFunc(dispatch, err)
            })
            .finally(() => {
                dispatch(setMainLoading(false));
            })
    };
    const filteredDivList = useMemo(() => {
        let tempL = [];
        let orgId = parseInt(filter.org_id);
        for (let div of divList) {
            if (parseInt(div.org_id) === orgId) {
                tempL.push(div);
            }
        }
        return tempL;
    }, [filter.org_id, divList]);
    const performTransferAction = (dt_id, status) => {
        dispatch(setMainLoading(true));
        PostAxios(`users/transfer-request-action`, { dt_id, status }, accessToken)
            .then(({ data }) => {
                if (data.status === "1") {
                    dispatch(setToastData({ message: `${data.message} `, isHtml: true, type: 'success', showCloseBtn: true }));
                    fetchTransferList(1);
                }
                else {
                    dispatch(setToastData({ message: (data.errors) ? ConvertErrorArrayToString(data.errors) : data.message, isHtml: true, type: 'error', showCloseBtn: true }))
                }
            })
            .catch(err => {
                responseCatchFunc(dispatch, err);
            })
            .finally(() => {
                dispatch(setMainLoading(false));
            })
    }
    return (
        <div className="main-form-sec">
            {
                (userData.role_slug === "super_admin" || userData.role_slug === 'org_admin' || userData.role_slug === 'div_admin' || userData.role_slug === 'captain') &&
                <div className="top-right-btn p-0">
                    <Link
                        to={"create-transfer-request"}
                        className="btn-blue btn br-0"
                    >
                        Create Request
                    </Link>
                </div>
            }
            {
                (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") &&
                <div className="top-reports-filter">
                    <div className={`right-filter-sec`}>
                        <button className="filter-toggle" onClick={() => {
                            setShowFilter(!showFilter);
                        }}>
                            <i className="fa-solid fa-filter"></i>
                        </button>
                        <div className={`p-0 filter-search form-field-group report-filter  ${(showFilter) ? '' : 'filter-active'}`}>
                            {
                                userData.role_slug === "super_admin" &&
                                <div className="report-filter-field">
                                    <label className="select-input-outer">Organization</label>
                                    <div className="static-items-outer">
                                        <select
                                            id="org_id"
                                            name="org_id"
                                            className="select-input"
                                            value={filter.org_id}
                                            onChange={(e) => setFilter({ ...filter, "org_id": e.target.value, div_id: 0 })}
                                        >
                                            <option value='0'>Choose Organization</option>
                                            {
                                                orgList.length > 0 && orgList.map((item, index) => <option key={`org-${index}`} value={item.ID}>{item.short_name}</option>)
                                            }
                                        </select>
                                    </div>
                                </div>
                            }
                            {
                                (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") &&
                                <div className="report-filter-field">
                                    <label className="select-input-outer">Division</label>
                                    <div className="static-items-outer">
                                        <select
                                            id="div_id"
                                            name="div_id"
                                            className="select-input"
                                            value={filter.div_id}
                                            onChange={(e) => filterHandler("div_id", e.target.value)}
                                        >
                                            <option value='0'>All</option>
                                            {
                                                filteredDivList.length > 0 && filteredDivList.map((item, index) => <option key={`div-list-${index}`} value={item.ID}>{item.division_name} {`(${item.division_number})`}</option>)
                                            }
                                        </select>
                                    </div>
                                </div>
                            }
                            <button type="button" className="btn btn-blue ms-2" onClick={() => { setCurrentPage(1); fetchTransferList(1); }}>Submit</button>
                        </div>
                    </div>
                </div>
            }
            <div className="table-wrapper">
                <table className="table">
                    <thead>
                        <tr>
                            <th>S.No.</th>
                            <th>ITS</th>
                            <th>Name</th>
                            <th>Division From</th>
                            <th>Division To</th>
                            <th>Requested By</th>
                            <th>Requested On</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            transferList.length > 0 && transferList.map((item, index) => {
                                return <tr key={`user-id-${index}-${item.id}`}>
                                    <td>{(currentPage - 1) * paginationData.per_page + index + 1}</td>
                                    <td>{item.user_its}</td>
                                    <td>{item?.mem_full_name.trim()}</td>
                                    <td>{item.div_from_name}</td>
                                    <td>{item.div_to_name}</td>
                                    <td>{item.request_full_name.trim()}</td>
                                    <td>{moment(item.req_added_on).format('DD, MMM YYYY hh:mm A')}</td>
                                    <td>
                                        {
                                            (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") ?
                                            <>
                                                {
                                                    parseInt(item.req_status) === 0 &&
                                                    <>
                                                        <button className="status-btn bg-btn approved" onClick={() => {
                                                            performTransferAction(item.dt_id, 1);
                                                        }}>Approve</button>
                                                        <button className="status-btn bg-btn rejected ms-2" onClick={() => {
                                                            performTransferAction(item.dt_id, 2);
                                                        }}>Reject</button>
                                                    </>
                                                }                                                
                                            </> : parseInt(item.req_status) === 0 && <span className="status-text verification-pending" style={{cursor:'default'}}>Pending</span>
                                        }
                                        {
                                                parseInt(item.req_status) === 1 && <>
                                                <span className="status-text approved">Approved {`(${moment(item.req_updated_on).format('DD, MMM YYYY hh:mm A')})`}</span>
                                            </>
                                        }
                                        {
                                            parseInt(item.req_status) === 2 && <>
                                                <span className="status-text rejected">Rejected {`(${moment(item.req_updated_on).format('DD, MMM YYYY hh:mm A')})`}</span>
                                            </>
                                        }
                                    </td>
                                </tr>
                            })
                        }
                    </tbody>
                </table>
            </div>
            <Pagination
                currentPage={currentPage}
                totalCount={paginationData.total}
                pageSize={paginationData.per_page}
                onPageChange={page => {
                    setCurrentPage(page);
                    fetchTransferList(page);
                }}
            />
        </div>
    )
}

export default DivisionTransfer;